const EmptyDataRenderer = (props) => {
  const { customComponentName } = props;

  // Format the component name from "abc-def-ghi" to "Abc Def Ghi"
  const formatComponentName = (name) => {
    if (!name) return "";

    return name
      .split("-")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };

  const formattedName = formatComponentName(customComponentName);

  return (
    <div className="additional-fields-container">
      <h5>{formattedName || "Unknown Component"}</h5>
    </div>
  );
};

export default EmptyDataRenderer;
